var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"infinite-scroll"},[(_vm.loading)?_c('bunt-progress-circular',{attrs:{"size":"huge","page":true}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }